import React from 'react';
import {
  Stack,
  Text,
  SegmentedSelection,
} from '@piwikpro/ui-components';
import { TFunction } from 'react-i18next';

type Period = 'year' | 'month'

export const PlanCard: React.FunctionComponent<{
  header: string
  priceHeader: React.ReactNode
  subheader: React.ReactNode
  children: React.ReactNode
  badge?: React.ReactNode
  onPeriodChange?: (period: Period) => void
  period?: Period
  t: TFunction
}> = ({
  header,
  priceHeader,
  subheader,
  children,
  badge,
  onPeriodChange,
  period,
  t,
}) => (
  <Stack vertical spacing="narrow">
    <Stack.Item fill>
      <Stack verticalAlignment="center">
        <Stack.Item fill>
          <Text as="h2" align="left" size={20} weight={700} wrapType="noWrapAndCutText" dataId="Header.medium">
            <div style={{ whiteSpace: 'break-spaces' }}>
              {header}
            </div>
          </Text>
        </Stack.Item>
        <Stack.Item>
          {badge && (
            <Stack spacing="none">
              <Stack.Item previousSpacing="wide">
                {badge}
              </Stack.Item>
            </Stack>
          )}
          {onPeriodChange && (
            <Stack spacing="none">
              <Stack.Item previousSpacing="wide">
                <SegmentedSelection
                  items={[
                    { value: 'year', name: t('marketing.change-plan-overlay.period-selector.yearly') },
                    { value: 'month', name: t('marketing.change-plan-overlay.period-selector.monthly') },
                  ]}
                  onChange={(v) => { onPeriodChange(v as Period); }}
                  value={period || 'year'}
                />
              </Stack.Item>
            </Stack>
          )}
        </Stack.Item>
      </Stack>
    </Stack.Item>
    <Stack.Item>
      {priceHeader}
    </Stack.Item>
    <Stack.Item>
      <Text as="p" color="InkLighter">
        {subheader}
      </Text>
    </Stack.Item>
    <Stack.Item fill previousSpacing="default">
      {children}
    </Stack.Item>
  </Stack>
);
